import { Component, OnInit, Input } from '@angular/core';
import { Barcode, BarcodeQuery, MemberCardQuery, MemberDetails, MemberQuery, PopulationQuery } from '@fgb/core';
import { BarcodeService } from '@fgb/core';
import { map, Observable } from 'rxjs';
import { MemberCard } from '@fgb/core';
import { Populations } from 'src/app/shared/utilities/populations';
import { calculateAge, getKidType, KidTypeE, KidTypeT } from 'src/app/shared/utilities/age-ranges';

@Component({
  selector: 'fgb-barcode',
  templateUrl: './barcode.component.html',
  styleUrls: ['./barcode.component.scss'],
})
export class BarcodeComponent implements OnInit {
  @Input() isWalletPage: string;
  @Input() isHomePage: boolean = false;
  @Input() isMenu: boolean = false;
  barcode$: Observable<Barcode>;
  card$: Observable<MemberCard | undefined>;
  member$: Observable<MemberDetails | undefined>;
  memberDetails$: Observable<{ FirstName: string; Surname: string; kidType: KidTypeT }>;
  isKid: boolean;
  populations = Populations;
  KidType = KidTypeE;

  constructor(
    private barcodeService: BarcodeService,
    private barcodeQuery: BarcodeQuery,
    private memberCardQuery: MemberCardQuery,
    private memberDetailsQuery: MemberQuery,
    private memberQuery: MemberQuery,
    private populationQuery: PopulationQuery
  ) {}

  ngOnInit() {
    this.barcodeService.fetchBarcode().toPromise();
    this.barcode$ = this.barcodeQuery.select();
    this.member$ = this.memberDetailsQuery.selectMemberDetails();
    this.card$ = this.memberCardQuery.selectCurrentCard();
    this.memberDetails$ = this.memberQuery.selectMemberDetails().pipe(
      map((m) => {
        if (m) {
          const age = calculateAge(new Date(m.DOB));
          const kidType = getKidType(age);
          return { FirstName: m.FirstName, Surname: m.Surname, kidType };
        }
        return { FirstName: '', Surname: '', kidType: 'Other' };
      })
    );
    this.isKid = this.populationQuery.userInPopulation([this.populations.Kids]);
  }
}
